import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocalization } from "../hooks/useLocalization";
import { useAuth } from "../hooks/useAuth";
import { EagleState } from "./EagleState";

/** Shown in place of a page's normal content whenever its primary data request comes back
 * 403 (the account is authenticated but lacks the required permission). Never redirects and
 * never touches the URL - the user stays on the route they navigated to, sees a clear
 * explanation instead of a crash or a misleading empty list, and gets a safe way back to
 * their own dashboard. */
export const AccessDenied = ({ resourceLabel, testId = "access-denied-state" }) => {
  const { t } = useLocalization();
  const { user } = useAuth();

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn(
      `[access-denied] role=${user?.role || "unknown"} path=${window.location.pathname}` +
        (resourceLabel ? ` resource=${resourceLabel}` : "")
    );
  }, [resourceLabel, user]);

  const homeHref = user?.active_portal === "STAFF" ? "/employee" : "/management";

  return (
    <div className="min-h-[50vh] flex items-center justify-center" data-testid={testId}>
      <div className="max-w-sm text-center">
        <EagleState
          variant="denied"
          title={t("accessDeniedPage.title")}
          message={resourceLabel ? t("accessDeniedPage.messageWithResource", { resource: resourceLabel }) : t("accessDeniedPage.message")}
          testId={`${testId}-eagle`}
        />
        <p className="text-xs text-gray-500 -mt-4 mb-4">{t("accessDeniedPage.contactAdmin")}</p>
        <Link
          to={homeHref}
          data-testid="access-denied-home-link"
          className="inline-block px-5 py-2 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 active:scale-95 transition-all"
        >
          {t("accessDeniedPage.goHome")}
        </Link>
      </div>
    </div>
  );
};
